import { createReducer, on } from '@ngrx/store';
import {
  addAuthor,
  addSpeech,
  editingSpeech,
  editSpeech,
  removeSpeech,
  setActiveSpeech,
} from '../actions/speech.action';
import SPEECHES from '../../../mock/speeches.mock';
import Swal from 'sweetalert2';
import { ISpeech } from 'src/interfaces/speech.interface';
import keyBy from 'src/utils/keyBy';

type StateProps = {
  data: ISpeech[];
  currentSpeech: any;
  authors: Array<string>;
  editing: boolean;
};

export const initialState: StateProps = {
  data: localStorage.speeches ? JSON.parse(localStorage.speeches) : SPEECHES,
  currentSpeech: {},
  authors: localStorage.authors
    ? JSON.parse(localStorage.authors)
    : ['Donald Trump', 'Barack Obama'],
  editing: false,
};

const _speechReducer = createReducer(
  initialState,
  on(addSpeech, (state: StateProps, payload) => {
    Swal.fire('Successfully Added Speech', '', 'success');
    const temp = [...state.data, payload.data];
    localStorage.setItem('speeches', JSON.stringify(temp));
    return {
      ...state,
      data: temp,
    };
  }),
  on(setActiveSpeech, (state: StateProps, payload) => {
    return {
      ...state,
      currentSpeech: payload.obj,
      editing: false,
    };
  }),
  on(addAuthor, (state: StateProps, payload) => {
    const temp = [...state.authors, payload.author];
    localStorage.setItem('authors', JSON.stringify(temp));
    return {
      ...state,
      authors: temp,
    };
  }),
  on(removeSpeech, (state: any) => {
    const temp = { ...keyBy([...state.data], 'id') };
    const id = { ...state.currentSpeech }.id;
    delete temp[id];
    const data = Object.values(temp);
    localStorage.setItem('speeches', JSON.stringify(data));
    return {
      ...state,
      data,
      currentSpeech: {},
    };
  }),
  on(editingSpeech, (state: StateProps) => {
    return {
      ...state,
      editing: true,
    };
  }),
  on(editSpeech, (state, payload) => {
    const temp = keyBy([...state.data], 'id');

    temp[state.currentSpeech.id] = {
      ...temp[state.currentSpeech.id],
      ...payload,
    };
    const data = Object.values(temp);
    localStorage.setItem('speeches', JSON.stringify(data));

    return {
      ...state,
      data,
      editing: false,
    };
  })
);

export function speechReducer(state: any, action: any) {
  return _speechReducer(state, action);
}
